import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://payyug.in/api";

// === Create Fee (POST) ===
export const createFee = createAsyncThunk(
  "fees/createFee",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(`${BASE_URL}/add-fee-master`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // { success, message, data }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);


export const fetchAllFees = createAsyncThunk(
  "fees/fetchAllFees",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const superadminId = filters.superadminId || localStorage.getItem("adminuserId");

      // ✅ Manually build query string to preserve spaces
      
  let applicableOn =   filters.applicableOn;
  let serviceType =   filters.serviceType;
  let service =   filters.service;
      // if (filters.applicableOn)
        
      // if (filters.serviceType)
      // let servicetype = filters.serviceType;
      // if (filters.service)
        // queryParams.push(`service=${encodeURIComponent(filters.service)}`);

      // const queryString = queryParams.join("&");

      const response = await axios.get(`${BASE_URL}/all-fee-master`, {


          params: {
          applicableOn,
          serviceType,
          service,
          superadminId, // ✅ filter applied
        },
      });

      return response.data; // { success, data: [...] }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);




// === Update Fee (PUT) ===
export const updateFee = createAsyncThunk(
  "fees/updateFee",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.put(
        `${BASE_URL}/update-fees-master/${id}`,
        data,
       
      );
      return response.data; // { success, message, data }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Update failed");
    }
  }
);

const feeAssignSlice = createSlice({
  name: "feeAssign",
  initialState: {
    allFees: [],
    loading: false,
    error: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // === createFee ===
      .addCase(createFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFee.fulfilled, (state, action) => {
        state.loading = false;
        const newFee = action.payload?.data;
        if (newFee) state.allFees.push(newFee); // instantly add
      })
      .addCase(createFee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // === fetchAllFees ===
      .addCase(fetchAllFees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFees.fulfilled, (state, action) => {
        // state.loading = false;
        // state.allFees = action.payload?.data || [];
        state.loading = false;
        console.log()
        if (action.payload.success) {
          state.allFees = action.payload.data || [];
        } else {
          state.allFees = [];
          state.error = action.payload.message || "No fees found for the given criteria";
        }
      })
      .addCase(fetchAllFees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // === updateFee ===
      .addCase(updateFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFee.fulfilled, (state, action) => {
        state.loading = false;
        const updatedFee = action.payload?.data;
        if (updatedFee?.id) {
          state.allFees = state.allFees.map((fee) =>
            fee.id === updatedFee.id ? updatedFee : fee
          );
        }
      })
      .addCase(updateFee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default feeAssignSlice.reducer;
